var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StIcon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.thisChannelObj.name),expression:"thisChannelObj.name"}],staticClass:"ma-3",attrs:{"icon-name":_vm.thisChannelObj.icon,"color":_vm.thisChannelObj.color,"size":"30"}})}
var staticRenderFns = []

export { render, staticRenderFns }